import {cardImages} from '../../assets/ImageIndex'

interface ElementType {
  type: string ;
  content: string | string[] | ElementType[]; // Ajuste para suportar listas ou elementos aninhados
  getStyles?: (breakpoints: {
    isDesktopOrLaptop?: boolean;
    isMiniNotebook?: boolean;
    isMobileBig?: boolean;
    isMobileMedium?: boolean;
    isMobileMini?: boolean;
  }) => React.CSSProperties;
}

const titleA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  textAlign: 'center',
  flexDirection: 'column',
  color: '#333',
  fontWeight: 'bold', 
  fontSize: isMobileMini ? '15px': isMobileMedium ? '17px': isMobileBig ? '18px': isMiniNotebook ? '20px' : '25px',
});

const titleB = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  textAlign: 'center',
  flexDirection: 'column',
  color: '#333',
  fontWeight: 'bold', 
  fontSize: isMobileMini ? '20px': isMobileMedium ? '22px': isMobileBig ? '25px': isMiniNotebook ? '28px' : '30px',
});

const brA = (isDesktopOrLaptop: boolean) => ({
  height: '8px',
});
const brB = (isDesktopOrLaptop: boolean) => ({
  height: '5px',
});
const brC = (isDesktopOrLaptop: boolean) => ({
  height: '3px',
});


const textA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  width: isMobileMini ? '310px': isMobileMedium ? '460px': isMobileBig ? '570px': isMiniNotebook ? '650x' : '700px',

  textAlign: 'justify',
});

const textB = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  //width: isMobileMini ? '260px': isMobileMedium ? '260px': isMobileBig ? '450px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const textC = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '15px': isMobileBig ? '50px': isMiniNotebook ? '50x' : '55px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '15px': isMobileBig ? '50px': isMiniNotebook ? '50x' : '55px',
  //width: isMobileMini ? '260px': isMobileMedium ? '260px': isMobileBig ? '450px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const divA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': isMobileMini ? 'column': isMobileMedium ? 'column': isMobileBig ? 'column': isMiniNotebook ? 'row' : 'row', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const divB = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': 'column', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const divC = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': 'column', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const listA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
    color: '#333',
    fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
    gap: isMobileMini ? '8px': isMobileMedium ? '10px': isMobileBig ? '15px': isMiniNotebook ? '18px' : '18px',
    textAlign: 'justify',
    width: isMobileMini ? '290px': isMobileMedium ? '440px': isMobileBig ? '550px': isMiniNotebook ? '680x' : '880px',
})

const imageA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '325px': isMobileMedium ? '400px': isMobileBig ? '400px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '400px' : '450px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px',
})

const imageB = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '240px': isMobileMedium ? '380px': isMobileBig ? '360px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '300px' : '320px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px',
})

const imageC = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '220px': isMobileMedium ? '300px': isMobileBig ? '270px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '270px' : '270px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px',
})


const linkA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
}: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
}) => ({
  color: '#fff', // Azul padrão para links
  textDecoration: 'none', // Remove sublinhado padrão
  fontSize: isMobileMini ? '13px' : isMobileMedium ? '14px' : isMobileBig ? '16px' : isMiniNotebook ? '18px' : '18px',
  width: isMobileMini ? '150px' : isMobileMedium ? '160px' : isMobileBig ? '175px' : isMiniNotebook ? '220px' : '250px',
  display: "inline-block",
  padding: "10px 15px",
  backgroundColor: "#007bff", // Cor de botão (altere conforme necessário)
  borderRadius: "5px",
  textAlign: "center",
  fontWeight: "bold",
  transition: "background-color 0.3s",
  margin: "0 auto",
  
  ':hover': {
    color: '#0056b3', // Azul mais escuro no hover
    textDecoration: 'underline',
  },
  
  ':active': {
    color: '#004494', // Azul ainda mais escuro no clique
  }
});


export const card_13_02_25 = {

  date: '13-02-2025',
  routeCard: '/nutricao/top-5-marcas-whey/13-02-2025',
  description: 'Whey, melhores marcas, preços baixos',
  month: 'Fevereiro',
  shortTitle: 'Descontos Whey Protein 2025',
  elements: [
    {
      type: 'title',
      content: 'Melhores Marcas de Whey Protein: uma avaliação',
      getStyles: titleA,
    },
    {
      type: 'div',
      content: [
    {
            type: 'image',
            content: cardImages.WheyProteinPhoto_25_01_25,
            getStyles: imageA,
          },
        
        ],
        getStyles: divA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">
          O whey protein é uma ótima fonte de aminoácidos essenciais e geralmente vem concentrado em proteínas e derivados do leite. 
          Em sua forma isolada por exemplo chega a ter 99% de proteina em sua composição, o restante é constituído de gordura e açúcar.
          Por esse motivo mesmos os intolerantes à lactose podem ingerir a forma isolada que não há contra indicações. Para uma intolerância moderada,
          o uso do whey concentrado (80%) não oferece nenhum risco. 
          
          <p style="text-indent: 20px;">  Porem os alérgicos à lactose tem uma reação mais adversa à ingestão desses produtos. 
          A recomendação é que não seja ingerido nenhum derivado do leite. Nestes casos temos a opção do Whey Protein sem Lactose.
         </p>
          <br></br>
          `,
          getStyles: textA,
        },
        {
          type: 'image',
          content: cardImages.WheyProteinMuscle_25_01_25,
          getStyles: imageA,
        },
      ],
      getStyles: divA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">
          O Whey, além de uma ótima fonte de proteína, sua praticidade, custo benefício, torna uma das escolhas mais populares para quem pratica academia e busca a construção muscular. 
         </p>
          <br></br>
          `,
          getStyles: textB,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'div',
      content: [
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">
          Abaixo elaboramos uma lista dos melhores whey protein do mercado, lembrando que a economia é maior nas opções com maior quantidade por embalagem.
         </p>
          <br></br>
          `,
          getStyles: textB,
        },
      ],
      getStyles: divB,
    },
    {
          type: 'title',
          content: 'Top 5 Marcas Whey Protein do Mercado',
          getStyles: titleA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'title',
          content: 'Whey Protein Isolado Six Gold ',
          getStyles: titleA,
        },
        {
        type: 'div',
        content: [
          {
          type: 'div',
          content: [
            {
              type: 'text',
             content: `
              <p style="text-indent: 20px;">
              O  Whey Protein Isolado Six Gold da BodyBuilders é a principal escolha para quem pratica musculação. 
              Uma proteína isolada e disponível em 3 sabores, baunilha, chocolate e morango. 
              Vem na quantidade de 2 kg. Há ainda a opção em pote ou sachê.     
             </p>
              `,
              getStyles: textC,
            },
            {
              type: 'text',
              content: `
               <p style="text-indent: 20px;">
               Garanta já com um desconto, basta acessar o link:  
              </p>
               `,
               getStyles: textC, 
            },
            {
              type: 'link',
              content: 'https://amzn.to/4b4m8Cr',
              label: "Desconto Amazon",
              getStyles: linkA,
            },
            {
              type: 'br',
              content: '',
              getStyles: brA,
            },
          ],
          getStyles: divC,
          },
          {
            type: 'image',
            content: cardImages.BodyBuildersGoldCan_13_02_25,
            getStyles: imageB,
          },
        ],
        getStyles: divA,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'title',
          content: 'Isolate Protein Fuse da Dark Lab',
          getStyles: titleA,
        },
        {
        type: 'div',
        content: [
          {
          type: 'div',
          content: [
            {
              type: 'text',
             content: `
              <p style="text-indent: 20px;">
              Mais um ótimo Whey Protein da Dark Lab, empresa que oferece diversas soluções relacionadas a suplementação e nutrição para atletas de alta performance. 
              Seu produto apresenta na forma de um whey isolado, 99% de pureza.  
              Vem na quantidade de 1,8kg e nas opções de baunilha, chocolate ou morango.   
             </p>
              `,
              getStyles: textC,
            },
            {
              type: 'text',
              content: `
               <p style="text-indent: 20px;">
               Garanta já com um desconto, basta acessar o link:  
              </p>
               `,
               getStyles: textC, 
            },
            {
              type: 'link',
              content: 'https://amzn.to/4b1hbue',
              label: "Desconto Amazon",
              getStyles: linkA,
            },
            {
              type: 'br',
              content: '',
              getStyles: brA,
            },
          ],
          getStyles: divC,
          },
          {
            type: 'image',
            content: cardImages.DarkLab_13_02_25,
            getStyles: imageB,
          },
        ],
        getStyles: divA,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'title',
      content: 'Melhores Promoções',
      getStyles: titleB,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'title',
          content: 'Kit 2x Super Whey Max Titanium',
          getStyles: titleA,
        },
        {
        type: 'div',
        content: [
          {
          type: 'div',
          content: [
            {
              type: 'text',
             content: `
              <p style="text-indent: 20px;">
              Mais uma super oferta da Max Titanium . Uma otima opção para ter uma boa fonte protéica, num valor acessível. 
              São 2 kits whey de 900grama totalizando 1800g. A Max Titanium é referência quando se trata de proteínas isoladas e concentradas. 
              Vem na opção Baunilha, chocolate ou morango.   
             </p>
              `,
              getStyles: textC,
            },
            {
              type: 'text',
              content: `
               <p style="text-indent: 20px;">
               Garanta já com um desconto, basta acessar o link:  
              </p>
               `,
               getStyles: textC, 
            },
            {
              type: 'link',
              content: 'https://amzn.to/3QoH0ux',
              label: "Desconto Amazon",
              getStyles: linkA,
            },
            {
              type: 'br',
              content: '',
              getStyles: brA,
            },
          ],
          getStyles: divC,
          },
          {
            type: 'image',
            content: cardImages.SuperWheyMax_13_02_25,
            getStyles: imageC,
          },
        ],
        getStyles: divA,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'div',
      content: [
        {
          type: 'title',
          content: 'Kit 2x Whey Pro Protein Isolado e Concentrado 36g proteina 1,8KG (Cookies & Cream)',
          getStyles: titleA,
        },
        {
        type: 'div',
        content: [
          {
          type: 'div',
          content: [
            {
              type: 'text',
             content: `
              <p style="text-indent: 20px;">
              Uma super oferta da Body Nutri, um kit de 2 pacotes de whey de 1,8kg cada, totalizando 3,6kg no total!
              Esta proteína isolada é um dos melhores custos benefícios para aqueles que desejam construir seus musculos gastando menos.
              E vem em diversos sabores: Cokies and Cream, Banana Caramelizada, Chocolate Suiço, Creme de Baunilha, Leite Fermentado e Morango.
              Possui ampla variedade e não deixará o paladar repetitivo.   
              </p>
              `,
              getStyles: textC,
            },
            {
              type: 'text',
             content: `
              <p style="text-indent: 20px;">
              O produto fornece 18 g de proteínas, 8 g de BCAA e 6 g de glutamina por porção. São quase 36g de proteínas (*Valores referentes a 2 porções diárias recomendadas), 
              alem de conter  26 tipos de vitaminas e minerais, incluindo Sódio, Cálcio, Cobre, Cromo, Colina, Ferro, Flúor, Iodo, Magnésio, Manganês, Molibdênio, Selênio, Zinco,
              Ácido fólico, Ácido pantotênico, Biotina, Niacina, Vitaminas A, B1, B2, B6, B12, C, E, D3 e K. 
              </p>
              `,
              getStyles: textC,
            },
            {
              type: 'text',
              content: `
               <p style="text-indent: 20px;">
               Garanta já com um desconto, basta acessar o link:  
              </p>
               `,
               getStyles: textC, 
            },
            {
              type: 'link',
              content: 'https://amzn.to/3EtTI8I',
              label: "Desconto Amazon",
              getStyles: linkA,
            },
            {
              type: 'br',
              content: '',
              getStyles: brA,
            },
          ],
          getStyles: divC,
          },
          {
            type: 'image',
            content: cardImages.BodyNutriWheyPro_13_02_25,
            getStyles: imageA,
          },
        ],
        getStyles: divA,
        },
      ],
      getStyles: divB,
    },
    
  ] as ElementType[],
  tags: ['nutrição', 'Whey Protein', 'Whey', 'proteína', 'suplemento', 'promoção'],
  author: 'John Doe',
}

